<template>
  <Headline
    tag="h4"
    :size="size"
    :badge="badge"
    class="tracking-wide"
    data-test-id="filter-group-headline"
  >
    {{ label }}
    <template #badge="{ badge: number }">
      <span
        v-if="number && +number > 0"
        class="ml-1 bg-black px-2 py-1 text-xs leading-3 text-white"
      >
        {{ number }}
      </span>
    </template>
  </Headline>
</template>

<script setup lang="ts">
import Headline from '#layers/base/components/ui/headlines/Headline.vue'

type FilterGroupHeadlineProps = {
  size?: '2xl' | 'xl' | 'lg' | 'base' | '2sm' | 'sm' | 'xs'
  label?: string
  badge?: number
}

withDefaults(defineProps<FilterGroupHeadlineProps>(), {
  size: 'xs',
  label: '',
  badge: 0,
})
</script>
